import { useLayoutEffect, useState } from "react";

// Intercom inline banners reserve space by changing the body's top margin.
// Fixed navigation does not inherit that space. Read the reserved margin rather
// than relying on Intercom's private iframe markup or a fixed banner height.
export default function usePageTopOffset() {
  const [offset, setOffset] = useState(0);

  useLayoutEffect(() => {
    const update = () => {
      const margin = Number.parseFloat(getComputedStyle(document.body).marginTop);
      setOffset(Number.isFinite(margin) ? Math.max(0, margin) : 0);
    };
    const observer = new MutationObserver(update);
    const options = { attributes: true, attributeFilter: ["style", "class"] };
    observer.observe(document.body, options);
    observer.observe(document.documentElement, options);
    window.addEventListener("resize", update);
    update();

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  return offset;
}
